import { Injectable, inject } from '@angular/core';
import { Message, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  TOAST_KEY = 'global-toast';

  messageService = inject(MessageService);

  async add(message: Message): Promise<void> {
    this.messageService.add({key: this.TOAST_KEY, life: 2500, ...message});
  }

  async error(detail: string): Promise<void> {
    this.add({ severity: 'error', summary: 'Erro', detail });
  }

  async success(detail: string): Promise<void> {
    this.add({ severity: 'success', summary: 'Sucesso', detail });
  }
}
